import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import numbers from "core/numbers";

import { Swiper, SwiperSlide } from "swiper/react";

import Box from "ui/atom/Box";
import Icon from "ui/atom/Icon";

import { usePay } from "features/pay/fabric";

import "swiper/css";


const Slide = ({ option }) => {
	const style = {
		root: { alignItems: "center" },
		text: { textAlign: "center", cursor: "default" }
	};
	return (
		<SwiperSlide>
			<Box.Column gap={2} sx={style.root}>
				<Icon.Coin size={62} />
				<Box.Column sx={style.text}>
					<Typography variant="h5" color="text.primary">{numbers.format(option.tokens, "number")} Tokens</Typography>
					<Typography variant="body3" color="text.secondary">{numbers.format(option.price, "currency")}</Typography>
				</Box.Column>
			</Box.Column>
		</SwiperSlide>
	);
};
Slide.displayName = "SwiperSlider";

export default function Slider() {
	const pay = usePay();
	const theme = useTheme();

	const style = {
		swiper: {
			"& .swiper": { padding: theme.spacing(1.25, 0) },
			"& .swiper-slide": {
				padding: "14px 8px 11px 8px",
				borderRadius: "12px",
				background: theme.palette.background.dark
			},
			"& .swiper-slide-active": {
				outline: `4px solid ${theme.palette.tertiary.main}`,
				boxShadow: `0 4px 20px 0 ${theme.palette.tertiary.main + "8c"}`
			}
		}
	};

	const change = (e) => pay.store.setToken(pay.options[e.activeIndex]);

	return (
		<Box sx={style.swiper}>
			<Swiper initialSlide={1} slidesPerView={3.25} spaceBetween={10} grabCursor={false} centeredSlides slideToClickedSlide height="max-content" onSwiper={change} onSlideChange={change}>
				{pay.options?.map((o, i) => <Slide option={o} key={i} />)}
			</Swiper>
		</Box>
	);
}